/* eslint-disable react/jsx-no-comment-textnodes */
import type { ReactNode, ReactElement } from 'react';

import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// material
import { alpha, styled } from '@mui/material/styles';
import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Badge,
} from '@mui/material';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
// @ts-ignore legacy boundary
import { School } from '@mui/icons-material';
import useAuth from 'src/hooks/useAuth';
import PrereqsPopover from './PrereqsPopover';
import ChatPopover from './ChatPopover';
import TourHelpButton from 'src/components/TourHelpButton';
import LicenseExemptionChip from 'src/components/LicenseExemptionChip';
import AdminImpersonationChip from 'src/components/AdminImpersonationChip';
import { SwitchLanguageButton } from '../auth';
import { useTranslation } from 'react-i18next';

export interface DashboardNavbarProps {
  onOpenSidebar?: (...args: any[]) => any;
  [key: string]: any;
}
// import NotificationsPopover from './NotificationsPopover';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardNavbar({
  onOpenSidebar,
  trainingComplete,
  handleOpenTraining,
}: DashboardNavbarProps) {
  const { user, isImpersonating } = useAuth();
  const { t } = useTranslation('translation');

  return (
    <RootStyle>
      <ToolbarStyle>
        <Box display={{ md: 'block', lg: 'none' }}>
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: 'text.primary' }}
            size="large"
            data-tour="sidebar-toggle"
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </Box>

        {!user.is_executive && !user.is_corporate && <Searchbar />}
        <Box sx={{ flexGrow: 1 }} />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 0.25, sm: 0.5, md: 0.75 },
          }}
        >
          {!trainingComplete && (
            <Tooltip title={t('training-program.training-not-yet-completed')}>
              <IconButton onClick={handleOpenTraining} size="large">
                <Badge color="error" variant="dot">
                  <School />
                </Badge>
              </IconButton>
            </Tooltip>
          )}

          <PrereqsPopover />

          {user.account_type !== 'ADMIN' && !isImpersonating && (
            <TourHelpButton />
          )}

          {/*<NotificationsPopover />*/}
          <ChatPopover />
          {!user.is_executive &&
            !user.is_corporate &&
            user.account_type !== 'ADMIN' && (
              <SwitchLanguageButton
                containerProps={{
                  sx: {},
                }}
                size="large"
              />
            )}
          <LicenseExemptionChip />
          <AdminImpersonationChip />
          <AccountPopover />
        </Box>
      </ToolbarStyle>
    </RootStyle>
  );
}
